(function () {
  function init(root) {
    if (!root || root.dataset.blBannerReady) return;
    root.dataset.blBannerReady = '1';
    var track = root.querySelector('[data-bl-banner-track]');
    var slides = root.querySelectorAll('[data-bl-banner-slide]');
    var dots = root.querySelectorAll('[data-bl-banner-dot]');
    if (!track || slides.length < 1) return;
    var i = 0;
    var autoplay = parseInt(root.getAttribute('data-autoplay') || '0', 10) || 0;
    var loop = root.getAttribute('data-loop') !== 'false';
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(n) {
      if (!slides.length) return;
      if (loop) i = (n + slides.length) % slides.length;
      else i = Math.max(0, Math.min(slides.length - 1, n));
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function start() {
      stop();
      if (reduce || autoplay <= 0 || slides.length < 2) return;
      timer = setInterval(next, autoplay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var prevBtn = root.querySelector('[data-bl-banner-prev]');
    var nextBtn = root.querySelector('[data-bl-banner-next]');
    function bindActivate(el, fn) {
      if (!el) return;
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); fn(); start(); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); start(); }
      });
    }
    bindActivate(prevBtn, prev);
    bindActivate(nextBtn, next);
    dots.forEach(function (d) {
      bindActivate(d, function () {
        go(parseInt(d.getAttribute('data-bl-banner-dot'), 10) || 0);
      });
    });

    // swipe
    var x0 = null;
    track.addEventListener('pointerdown', function (e) { x0 = e.clientX; stop(); });
    track.addEventListener('pointerup', function (e) {
      if (x0 == null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      start();
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); start(); }
      if (e.key === 'ArrowLeft') { prev(); start(); }
    });
    root.tabIndex = 0;
    go(0);
    start();
  }
  function boot() {
    document.querySelectorAll('.bl-source-banner').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();